import { useContext } from 'react';
import RootStoreContext from 'contexts/root_store_context';
import RootStore from 'stores/root_store';

const useRootStore = (): RootStore => useContext(RootStoreContext);

export default useRootStore;
